import { useSuspenseQuery } from '@apollo/client';
import { UpdatePreferredUnitsForm } from '@features/preferencesCommon/components/UpdatePreferredUnitsForm';
import { type FC } from 'react';
import { GET_USER_PREFERRED_UNITS } from '../graphql/queries/getUserPreferredUnits';
import { TabProps } from '../types';

export const PreferredUnitsTab: FC<TabProps> = ({ userId }) => {
  const { data } = useSuspenseQuery(GET_USER_PREFERRED_UNITS, {
    variables: {
      input:
        userId != null
          ? {
              id: userId,
            }
          : null,
    },
    fetchPolicy: 'cache-and-network',
  });

  return (
    <UpdatePreferredUnitsForm
      entity={{
        type: 'user',
        id: userId,
      }}
      data={data.user.preferences.preferredUnits.configurations}
      factoryDefaults={data.user.preferences.preferredUnits.defaultValues}
    />
  );
};
